import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ALL_PERMISSIONS, PERMISSIONS } from '@models/auth.model';
import { NgxPermissionsGuard } from 'ngx-permissions';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'auth',
        loadChildren: () => import('@modules/auth/auth.module'),
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            except: ALL_PERMISSIONS,
            redirectTo: {
              [PERMISSIONS.accountant]: '/admin/n07',
              [PERMISSIONS.admin]: '/admin/n03',
              [PERMISSIONS.shop]: '/user/n08',
              [PERMISSIONS.user]: '/user/n08',
              [PERMISSIONS.store]: '/store/n44',
              [PERMISSIONS.sale_1]: '/admin/n16/n161',
              [PERMISSIONS.sale_2]: '/admin/n03/n031',
              [PERMISSIONS.nutrishop_1]: '/admin/n03/n031',
            },
          },
        },
      },
      {
        path: 'admin',
        loadChildren: () => import('@modules/admin/admin.module'),
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            only: [PERMISSIONS.accountant, PERMISSIONS.admin, PERMISSIONS.sale_1, PERMISSIONS.sale_2, PERMISSIONS.nutrishop_1],
            redirectTo: 'auth',
          },
        },
      },
      {
        path: 'user',
        loadChildren: () => import('@modules/user/user.module'),
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            only: [PERMISSIONS.shop, PERMISSIONS.user],
            redirectTo: 'auth',
          },
        },
      },
      {
        path: 'store',
        loadChildren: () => import('@modules/store/store.module'),
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            only: [PERMISSIONS.store],
            redirectTo: 'auth',
          },
        },
      },
      {
        path: '',
        redirectTo: 'auth',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
